import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import OnBoardForm from "./onBoardForm";
import EditIcon from "../editicon.png";
import { deleteManagerEmployee } from "../../../../Actions";
import { withTranslation, Trans } from "react-i18next";

class EmployeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDataOpen: false,
      employeeData: undefined,
      selectedEmployee: undefined,
      heightSet: 0
    };
    this.workHours = ["fullTime", "zeroHours", "agency"];
    this.openForm = this.openForm.bind(this);
    this.cancelForm = this.cancelForm.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    if (this.props.employeeData !== void 0) {
      this.setState({ employeeData: this.props.employeeData ,skillList: this.props.skillList});
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
    this.setState({ heightSet: document.body.scrollHeight });
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({ employeeData: this.props.employeeData });
      this.updateDimensions();
    }
  }
  openForm() {
    this.setState(state => ({
      formDataOpen: true,
      selectedEmployee: undefined
    }));
  }

  cancelForm() {
    this.setState(state => ({
      formDataOpen: false
    }));
  }
  openEditForm = data => {
    let payload = Object.assign({}, data);
    delete payload["otherDetails"];
    this.setState({ selectedEmployee: payload, formDataOpen: true });
  };
  DeleteEmployee = data => {
    let payload = Object.assign({}, data);
    delete payload["otherDetails"];
    this.props.dispatch(deleteManagerEmployee(payload));
  };
  skillLabelupdate = (employeeData) => {
    let skillData = this.props.skillList.filter((skillData) => {
      return Number(skillData.id) === Number(employeeData.skill);
    });
    return skillData;
  };
  render() {
    const { formDataOpen, employeeData, selectedEmployee } = this.state;
    var updatedHt = this.state.heightSet - 278;
    const empDivStyle = {
      maxHeight: updatedHt + "px"
    };
    const { t } = this.props
    return employeeData !== void 0 ? (
      <MainApp>
        <Wrapper>
          <Cont>
            <RowHead>
              <Column lg={2} md={2}>
                <Trans>name</Trans>
              </Column>
              <Column lg={1} md={1}>
                <Trans>sso</Trans>
              </Column>
              <Column lg={1} md={1}>
                <Trans>fullPartTime</Trans>
              </Column>
              {/* <Column lg={1} md={1}>
                <Trans>role</Trans>
              </Column> */}
              <Column lg={1} md={1}>
                <Trans>skill</Trans>
              </Column>
              {/* <Column lg={2} md={2}>
                <Trans>shiftAllocation</Trans>
              </Column> */}
              <Column lg={1} md={1}>
                <Trans>available</Trans>
              </Column>
              <Column>
                <NestedRow>
                  <Column lg={3} md={3}>
                    <Trans>startDate</Trans>
                  </Column>

                  <Column lg={4} md={4}>
                    <Trans>employmentEndDate</Trans>
                  </Column>
                  <Column lg={2} md={2}>
                    <Trans>edit</Trans>
                  </Column>
                </NestedRow>
              </Column>
            </RowHead>
            <div className="wrapper-Employee">
              <EmployeeDiv style={empDivStyle}>
                {employeeData.employeeDetails.map(employeeData => (
                  <RowCont key={employeeData.ssoId}>
                    <Column lg={2} md={2}>
                      {employeeData.firstName} {"  "} {employeeData.lastName}
                    </Column>
                    <Column lg={1} md={1}>
                      {employeeData.ssoId}
                    </Column>
                    <Column lg={1} md={1}>
                      {employeeData.workHours && t(this.workHours[employeeData.workHours - 1])}
                    </Column>
                    {/* <Column lg={1} md={1}>
                      {employeeData.role}
                    </Column> */}
                    <Column lg={1} md={1}>
                    {this.skillLabelupdate(employeeData).map((data) =>data.description)}
                    </Column>
                    {/* <Column lg={2} md={2}>
                      {employeeData.shiftAllocation}
                    </Column> */}
                    <Column lg={1} md={1}>
                      {employeeData.allocationPercentage ? (employeeData.allocationPercentage) : ("0")}%
                    </Column>
                    <Column>
                      <NestedRow>
                        <Column lg={3} md={3}>
                          {employeeData.startDate}
                        </Column>
                        <Column lg={4} md={4}>
                          {employeeData.employmentEndDate}
                        </Column>
                        <Column lg={2} md={2}>
                          <ImageDiv
                            onClick={() => {
                              this.openEditForm(employeeData);
                            }}
                          >
                            <Img src={EditIcon} alt="edit" />
                          </ImageDiv>
                        </Column>
                      </NestedRow>
                    </Column>
                  </RowCont>
                ))}
              </EmployeeDiv>
            </div>
          </Cont>
        </Wrapper>
        <FooterData
          formDataOpen={formDataOpen}
        // heightData={updatedHt - this.state.heightSet}
        >
          {!formDataOpen ? (
            <p>
              <Button onClick={this.props.BackTab}>
                <Trans>back</Trans>
              </Button>
            </p>
          ) : (
              <OnBoardForm
                onClose={this.cancelForm}
                workHours={this.workHours}
                empoyeeData={selectedEmployee}
              />
            )}
        </FooterData>
      </MainApp>
    ) : (
        <div />
      );
  }
}

const mapStateToProps = ({ auth, userMessage, managerTimesheetData }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    employeeData: managerTimesheetData.payload.weekDataDetails,
    skillList: managerTimesheetData.payload.technicianTypeList
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(EmployeeList))
);

const MainApp = styled.div`
  position: relative;
  .wrapper-Employee{
    overflow-y:auto;
    height: auto;
    padding-top: 5px;
  }
`;
const EmployeeDiv = styled.div`
  margin: 20px 50px 0px !important;
`;
const Wrapper = styled.div`
  margin: 20px auto 0 auto;
  font-family: Trebuchet MS;
`;
const Column = styled(Col)`
  && {
    font-size: 16px;
    color: #000;
    font-weight: normal;
    text-align: left;
    padding: 10px 0 10px 10px;
    overflow-wrap: break-word;
  }
`;
const NestedRow = styled(Row)`
  margin-left: 0px !important;
  margin-right: 0px !important;
  && {
    margin: 0;
  }
  && ${Column} {
    padding: 0;
  }
`;
const RowHead = styled(Row)`
  background: #f1f4f9;
  padding-right: 10px;
  margin: 20px 50px 0px !important;
  ${Column} {
    font-size: 12px;
    color: #000;
    font-weight: bold;
    text-align: left;
    padding: 5px 0px 5px 10px;
  }
`;
const RowCont = styled(Row)`{
  margin-left: 0px!important;
  margin-right: 0px !important;
`;
const Cont = styled(Container)`
padding:0px !important
  && {
    max-width: none;
  }
`;
const Img = styled.img`
  height: 15px;
  width: 15px;
`;
const ImageDiv = styled.div``;
const FooterData = styled.div`
  border-top: 1px solid #babec3;
  background: #f1f4f9;
  height: 70px;
  padding-top: 15px;
  text-align: center;
  position: fixed;
  bottom: 0px;
  right: 0px;
  width: 101%;
  margin-left: 4px;
  && p {
    bottom: 0px;
    position: absolute;
    width: 100%;
  }
  ${({ formDataOpen, heightData }) =>
    formDataOpen &&
    `
    position: fixed !important;
    height: 330px;
    width:102%
  `}
`;
const Button = styled.button`
  background: #fff;
  border-radius: 30px;
  margin: 0 5px;
  padding: 0;
  border: 1px solid #babec3;
  height: 38px;
  width: 129px;
  font-weight: 50;
  position: relative;
  left: 8px;
  color: #000;
  font-size: 12px;
`;
